interface LogoProps {
  className?: string
  variant?: 'full' | 'icon'
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

// Full logo is wide (text), icon is tall (symbol)
const fullLogoSizes = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-12',
  xl: 'h-16',
}

const iconSizes = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-14',
  xl: 'h-20',
}

export function Logo({ className, variant = 'full', size = 'md' }: LogoProps) {
  if (variant === 'icon') {
    return (
      <img
        src="/logo-icon.svg"
        alt="Savorias"
        className={`${iconSizes[size]} w-auto ${className ?? ''}`}
      />
    )
  }

  return (
    <img
      src="/logo-full.svg"
      alt="Savorias"
      className={`${fullLogoSizes[size]} w-auto ${className ?? ''}`}
    />
  )
}
